import React from "react";
import { ButtonWithIcon } from "@components/atoms/buttons/button-with-icon/button-with-icon";
import magnifyingGlassDarkIcon from "@src/assets/svg/magnifying-glass-dark.svg";
import {
  updateShowAutoMatchBlueprintModal,
  updateShowMyBlueprintLibraryModal,
} from "@src/reducers/your-reducer";
import { useDispatch } from "react-redux";

import blueprintBannerImage from "@src/assets/png/blueprint-banner-image.png";
import grayClosedLockIcon from "@src/assets/svg/lock-closed-gray.svg";
import styles from "./big-blueprint-banner-auto-match.module.scss";
import { CheckedUnorderedList } from "@components/molecules/checked-unordered-list/checked-unordered-list";
import { GrayIconNotification } from "@components/molecules/gray-icon-notification/gray-icon-notification";
import { ColoredGradientBorderContainer } from "@src/components/templates/layouts/colored-gradient-border-container/colored-gradient-border-container";
import { AutoMatchBlueprintButton } from "@src/components/atoms/auto-match-blueprint-button/auto-match-blueprint-button";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { useI18N } from "@src/language/language-context";

const cssClassName = "big-blueprint-banner-auto-match";

export const BigBlueprintBannerAutoMatch = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const texts = {
    smallOrangeText: i18n(
      "modules.bigBlueprintBannerAutoMatch.smallOrangeText",
    ),
    gradientText: i18n("modules.bigBlueprintBannerAutoMatch.gradientText"),
    grayNotificationText: i18n(
      "modules.bigBlueprintBannerAutoMatch.grayNotificationText",
    ),
    grayNotificationAltText: i18n(
      "modules.bigBlueprintBannerAutoMatch.grayNotificationAltText",
    ),
    autoMatchBlueprintButton: i18n(
      "modules.bigBlueprintBannerAutoMatch.autoMatchBlueprintButton",
    ),
    myBlueprintLibraryButton: i18n(
      "modules.bigBlueprintBannerAutoMatch.myBlueprintLibraryButton",
    ),
    bluePrintExampeAltText: i18n(
      "modules.bigBlueprintBannerAutoMatch.bluePrintExampeAltText",
    ),
    uspList: [
      i18n("modules.bigBlueprintBannerAutoMatch.checkedList.firstElement"),
      i18n("modules.bigBlueprintBannerAutoMatch.checkedList.secondElement"),
      i18n("modules.bigBlueprintBannerAutoMatch.checkedList.thirdElement"),
    ],
  };

  const handleOpenMyBlueprintLibrary = () => {
    dispatch(updateShowMyBlueprintLibraryModal(true));
  };

  const handleAutoMatchBlueprint = () => {
    dispatch(updateShowAutoMatchBlueprintModal(true));
  };

  const initialStructureNodeset = getInitialStructureNodeset();

  return (
    <>
      <ColoredGradientBorderContainer>
        <div className={styles[cssClassName]}>
          <div className={styles[`${cssClassName}__inner-wrapper`]}>
            <div className={styles[`${cssClassName}__content-wrapper`]}>
              <div>
                <p className={styles[`${cssClassName}__small-orange-text`]}>
                  {texts.smallOrangeText}
                </p>
                <p className={styles[`${cssClassName}__gradient-text`]}>
                  {texts.gradientText}
                </p>
              </div>
              <div
                className={
                  styles[`${cssClassName}__list-and-notification-wrapper`]
                }
              >
                <CheckedUnorderedList list={texts.uspList} />
                <GrayIconNotification
                  text={texts.grayNotificationText}
                  altText={texts.grayNotificationAltText}
                  icon={grayClosedLockIcon}
                />
              </div>

              {initialStructureNodeset.getRootNode() && (
                <>
                  <AutoMatchBlueprintButton
                    fun={handleAutoMatchBlueprint}
                    text={texts.autoMatchBlueprintButton}
                    disabled={initialStructureNodeset.getRootNode() === null}
                  />
                  <ButtonWithIcon
                    fun={handleOpenMyBlueprintLibrary}
                    text={texts.myBlueprintLibraryButton}
                    icon={magnifyingGlassDarkIcon}
                    disabled={initialStructureNodeset.getRootNode() === null}
                  />
                </>
              )}
            </div>
            <div className={styles[`${cssClassName}__img-wrapper`]}>
              <img
                className={styles[`${cssClassName}__img`]}
                src={blueprintBannerImage}
                alt={texts.bluePrintExampeAltText}
              />
            </div>
          </div>
        </div>
      </ColoredGradientBorderContainer>
    </>
  );
};
